import api from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

export interface IMonthlyAverage {
  month: string
  average: number
  biannualAverage: number
}

export interface IProfessionalNPSParams {
  startDate: string
  endDate: string
}

interface IProfessionalNPSData {
  monthly_average: IMonthlyAverage[],
  biannual_average: number
}

export interface IProfessionalNPS {
  monthlyAverage: IMonthlyAverage[],
  biannualAverage: number
}

export const fetchProfessionalNPS = async ({
  startDate,
  endDate
}: IProfessionalNPSParams): Promise<IProfessionalNPS> => {
  const params = {
    start_date: startDate,
    end_date: endDate,
  }

  try {
    const { data } = await api.get<IProfessionalNPSData>(apiEndpoints.METRICS_PROFESSIONAL_NPS, { params })

    return {
      monthlyAverage: data.monthly_average,
      biannualAverage: data.biannual_average
    }

  } catch(error) {
    let message = 'Erro ao buscar NPS do profissional'
    if (error instanceof Error) {
      message = error?.message
    } else {
      message = String(error)
    } 
    
    return Promise.reject(message)
  }
}